import apiClient from '@/shared/services/api/apiClient';

import type {
  Interview,
  ScheduleInterviewPayload,
  RescheduleInterviewPayload,
} from '@/modules/hrPortal/types/interview.types';

export const getInterviewHistory = async (applicationId: string) => {
  return apiClient.get(
    `/hr-dashboard/interviews/${applicationId}`
  );
};

export const scheduleInterview = async (
  payload: ScheduleInterviewPayload
) => {
  return apiClient.post(
    '/hr-dashboard/interviews',
    payload
  );
};

export const rescheduleInterview = async (
  interviewId: string,
  payload: RescheduleInterviewPayload
) => {
  return apiClient.patch(
    `/hr-dashboard/interviews/${interviewId}/reschedule`,
    payload
  );
};

export const startInterview = async (interviewId: string) => {
  return apiClient.patch(
    `/hr-dashboard/interviews/${interviewId}/start`
  );
};

export const cancelInterview = async (
  interviewId: string,
  reason: string
) => {
  return apiClient.patch(
    `/hr-dashboard/interviews/${interviewId}/cancel`,
    { reason }
  );
};

export const noShowInterview = async (
  interviewId: string,
  reason: string
) => {
  return apiClient.patch(
    `/hr-dashboard/interviews/${interviewId}/no-show`,
    { reason }
  );
};

export const completeInterview = async (
  interviewId: string,
  result: 'PASSED' | 'FAILED',
  remarks?: string
) => {
  return apiClient.patch(
    `/hr-dashboard/interviews/${interviewId}/complete`,
    {
      result,
      interviewerRemarks: remarks,
    }
  );
};

export const uploadInterviewAttachments = async (
  interviewId: string,
  files: File[]
) => {
  const formData = new FormData();

  files.forEach((file) => {
    formData.append('attachments', file);
  });

  return apiClient.post(
    `/interview-attachments/${interviewId}`,
    formData
  );
};

export const getInterviewAttachments = async (
  interviewId: string
) => {
  return apiClient.get(
    `/interview-attachments/${interviewId}`
  );
};

export const deleteInterviewAttachment = async (
  attachmentId: string
) => {
  return apiClient.delete(
    `/interview-attachments/${attachmentId}`
  );
};